import { useLeadSources } from "@/hooks/useLeadSources";
import { useLeadSourceMutations } from "./hooks/useLeadSourceMutations";

export const useLeadSourceOperations = () => {
  const { data: leadSources } = useLeadSources();
  const { createLeadSource, updateLeadSource, deleteLeadSource, updateOrder } = useLeadSourceMutations();

  return {
    leadSources,
    createLeadSource: async (name: string, description: string) => {
      await createLeadSource.mutateAsync({
        name,
        description,
        order: leadSources ? leadSources.length + 1 : 1
      });
    },
    updateLeadSource: async (id: string, name: string, description: string) => {
      await updateLeadSource.mutateAsync({ id, name, description });
    },
    deleteLeadSource: async (id: string) => {
      await deleteLeadSource.mutateAsync(id);
    },
    updateOrder: async (leadSources: any[]) => {
      await updateOrder.mutateAsync(leadSources);
    },
  };
};